<mat-dialog-content>
  <p8-layout-settings-header [titlePath]="[getTitle()]" [iconRacine]="'warning'"></p8-layout-settings-header>
  <div class="p8-cm_dialog-validation__body mat-typography">
    <mat-progress-bar *ngIf="loading"></mat-progress-bar>
    <div style="padding-top: 10px;">
      <mat-divider></mat-divider>
      <div *ngIf="form.state === formState.draft">
        <p class="mat-h3 icon-text"><mat-icon>label_important</mat-icon>Le formulaire est prêt à être publié,&nbsp;<strong>il ne sera plus modifiable par la suite (champs et valeurs)</strong>.</p>
        <div class="mat-h4">
          <p>
            Seules les informations titre, description, signature courriel et courriel générique sur ce formulaire seront modifiables.<br/>
            Il sera toutefois possible de dupliquer ce formulaire pour en créer un nouveau et le modifier le cas échéant.
          </p>
        </div>
      </div>
      <mat-divider></mat-divider>
      <p class="mat-h3 icon-text"><mat-icon>label_important</mat-icon>Lien unique vers le formulaire pour les demandeurs</p>
      <app-url-proposal *ngIf="form && (form.url_obj || form.url_obj.length > 0)" [form]="form" (loaded)="onLoaded($event)" (editInPlace)="onEditInPlace($event)"></app-url-proposal>
      <mat-dialog-actions fxLayoutAlign="end" style="float: right">
        <button mat-raised-button
                (click)="close()">
          Abandonner et ne pas {{form.state === formState.draft ? 'publier' : 'mettre en ligne'}}
        </button>
        <button mat-raised-button
                [color]="'warn'"
                [disabled]="saveIsDisabled()"
                (click)="save()" >
          {{form.state === formState.draft ? 'Publier le formulaire' : 'Mettre en ligne'}}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</mat-dialog-content>

